import { Component, ViewEncapsulation, Input, Output, EventEmitter, ViewChild, inject } from '@angular/core';
import { GItem } from '@app/cp/shared/models/GItem';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import * as _ from 'lodash';
import { v_SupplierLocationBus } from '../../models/v_SupplierLocation';
import { OrderService } from '../../services/order.service';
import { GGItem } from '../../models/GGItem';

import { MessageType } from '../../enums/MessageType';
import { Message } from '../../models/message';
import { ComboBoxComponent, DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { DateFunctions } from '../../static/date-functions';
import { VendorService } from '../../services/vendor.service';
import { SupplierBus } from '../../models/SupplierBus';
import { UseFeatureFlagSet, IFeatureFlagSet } from '../../decorators/featureflags/featureflagset-decorator';
import { CommonValues } from "@app/cp/shared/static/CommonValues";

@UseFeatureFlagSet()
@Component({
    selector: 'supplier-info',
    templateUrl: './supplier-info.component.html',
    styleUrls: ['./supplier-info.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SupplierInfoComponent  {
    compFeatureFlagSet: IFeatureFlagSet = this as any; //Move this inside class
    private _vendorService = inject(VendorService);
    virtualizationSettings = CommonValues.virtualizationSettings;
    constructor( private svc_data: OrderService) {
        this.clear();
    }
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    @ViewChild('supplierOrSub') protected cboSupplierOrSub: ComboBoxComponent;
    @Input() readonly: boolean = false;
    @Input() set supplierLocation(value: v_SupplierLocationBus) {
        if (CommonFunctions.hasValue(value)) {
            this._supplierLocation = new v_SupplierLocationBus(value);
            this.isSubPO = this._supplierLocation.isSubContract;
            //            this.suppliersOrSubs = _.cloneDeep(this.suppliersOrSubPOs);
            // let supp = this.suppliersOrSubs.find(s => s.value === value.supplierId);

        }
        else {
            this.clear();
        }

        this.initializing = true;
        this.supplierId = this._supplierLocation.supplierId;
        this.supplierChanged(this.supplierId);
        this.supplierLocationId = this._supplierLocation.supplierLocationId;

    }
    get isCertExpired(): boolean {
        return (this.isSubPO && CommonFunctions.hasValue(this._supplierLocation) ? this._supplierLocation.isCertExpired : false);
    }
    protected _isSubPO: boolean = false;
    get isSubPO(): boolean {
        return this._isSubPO;
    }
    @Input() allSupplierLocations: GItem[];
    // @Input() suppliers: GGItem[];

    @Input() set suppliers(value: GGItem[]) {
        if (value !== this.allSuppliers) {
            this.allSuppliers = value;
            this.setActiveSuppliers(this.supplierId);
        }
    }
    @Input() set isSubPO(value: boolean) {
        if (value !== this._isSubPO) {
            this._isSubPO = value;
            this.setActiveSuppliers(this.supplierId);
        }
    }
    @Input() isRequired: boolean;

    _supplierLocation: v_SupplierLocationBus; // = new v_SupplierLocationBus();
    activeSuppliers: GGItem[];
    allSuppliers: GGItem[];
    supplier: SupplierBus;
    supplierLocations: GItem[];
    protected initializing: boolean = false;
    supplierId: any;
    supplierLocationId: any;
    suppliersOrSubPOsList: GGItem[];
    blankArray: GItem[] = [
        new GItem({ description: "", value: null, category: null, canSelect: true, "reference": null })
    ]

    // suppliersOrSubs: GGItem[];

    setPOTypeProperties() {
        this.suppliersOrSubPOsList = _.cloneDeep(this.suppliersOrSubPOs);
    }
    ngOnInit() {
        this.setPOTypeProperties();
    }
    getSupplierInfo(supId: any) {
        if (supId) {
            this._vendorService.get(supId).subscribe(data => {
                this.supplier = data;
            });
        }
    }

    suppliersInActive(itemArgs: { dataItem: any, index: number }) {
        if (itemArgs.dataItem == null || itemArgs.dataItem.canSelect == null) return false;
        return !itemArgs.dataItem.canSelect;
    }
    supplierLocationsInActive(itemArgs: { dataItem: any, index: number }) {
        if (itemArgs.dataItem == null || itemArgs.dataItem.canSelect == null) return false;
        return !itemArgs.dataItem.canSelect;
    }

    get suppliersOrSubPOs(): GGItem[] {
        let results: GGItem[] = [];
        if (CommonFunctions.hasArrayElementValue(this.suppliers)) {
            if (this.isSubPO) {
                results = this.suppliers.filter(s => s.flag === true);
            }
            else {
                results = this.suppliers.filter(s => s.flag === false);
            }
        }
        return results;
    }
    public getData(): v_SupplierLocationBus {
        return _.cloneDeep(this._supplierLocation);
    }
    public setActiveSuppliers(supplierId: string) {
        if (this.allSuppliers) {
            this.activeSuppliers = this.allSuppliers.filter(s => s.canSelect === true)
            var supcur = this.allSuppliers.find(s => s.canSelect === false && s.value == supplierId)
            if (supcur) {
                this.activeSuppliers.push(supcur);

            }
            if (this.isSubPO) {
                this.activeSuppliers = this.activeSuppliers.filter(s => s.flag === true);
            }
            else {
                this.activeSuppliers = this.activeSuppliers.filter(s => s.flag === false);
            }
        }
        else {
            this.activeSuppliers = [];
        }
    }
    public get hasSupplierLocs(): boolean {
        return CommonFunctions.hasArrayValue(this.allSupplierLocations);
    }
    clear() {
        this._supplierLocation = new v_SupplierLocationBus();
        this.supplierId = null;
        this.supplierLocationId = null;
        if (this.cboSupplierOrSub) {
            this.cboSupplierOrSub.reset();
        }
        this.changed();
        this.setActiveSuppliers(this.supplierId);
    }

    clearLocationEtc() {
        this.supplierLocationId = null;
        this._supplierLocation = new v_SupplierLocationBus();
    }
    supplierChanged(value: any) {
        //this.supplierLocationId = null;
        if (!this.initializing) {
            this.clearLocationEtc();
        }
        if (!this.allSupplierLocations) {
            this.allSupplierLocations = [];
        }
        if (CommonFunctions.hasValue(value)) {
            this.supplierLocations = this.allSupplierLocations.filter(s => s.category === value);
            if (CommonFunctions.arrayLength(this.supplierLocations) === 1 && this.supplierLocations[0].canSelect == true) {
                this.supplierLocationId = this.supplierLocations[0].value;
            }
            else if (!CommonFunctions.hasArrayElementValue(this.supplierLocations)) {
                this.supplierLocations = this.blankArray;
            }
        }
        else {
            this.clear();
        }
        if (this.compFeatureFlagSet.featureFlagSet["po-screen-for-both-subcontractors-and-suppliers-that-shows-the-information-from-the-general"]) {
            this.getSupplierInfo(value);
        }
        this.setActiveSuppliers(this.supplierId);
        this.supplierLocationChanged(this.supplierLocationId);
    }
    supplierLocationChanged(value: any) {
        if (CommonFunctions.hasValue(value)) {
            this.svc_data.getSupplierLocation(value).subscribe((data: v_SupplierLocationBus) => {
                if (data === null) {
                    this.clear();
                }
                this._supplierLocation = _.cloneDeep(new v_SupplierLocationBus(data));
                if (!this.initializing) {
                    this.changed();
                }
                this.initializing = false;
            });
        }
        else {
            this.supplierLocationId = null;
            if (!this.initializing) {
                this.changed();
            }
            this.initializing = false;
            //  this.clear();
        }
    }
    supplierCBOChanged(value: any) {
        this.supplierChanged(value);
    }
    supplierLocationCBOChanged(value: any) {
        this.supplierLocationChanged(value);
        //if (CommonFunctions.hasValue(value)) {
        //    this.svc_data.getSupplierLocation(value).subscribe((data: v_SupplierLocationBus) => {
        //        this._supplierLocation = _.cloneDeep(data);
        //    });
        //}
        //else {
        //    this.clear();
        //}
    }
    //supplierCBOChanged(value: GItem) {
    //    if (CommonFunctions.hasValue(value)) {
    //        this.supplierChanged(value.value);
    //    }
    //    else {
    //        this.clear();
    //    }
    //}
    //supplierLocationCBOChanged(value: GItem) {
    //    if (CommonFunctions.hasValue(value)) {
    //        this.svc_data.getSupplierLocation(value.value).subscribe((data: v_SupplierLocationBus) => {
    //            this._supplierLocation = _.cloneDeep(data);
    //        });
    //    }
    //    else {
    //        this.clear();
    //    }
    //}
    @Output() parentMessage: EventEmitter<Message> = new EventEmitter<Message>();
    sendParentMessage(type: MessageType, subject: string = null, message: string = null, values: any = null, value: any = null) {
        let msg: Message = new Message();
        msg.messageType = type;
        msg.messageSubject = subject;
        msg.message = message;
        msg.values = values;
        msg.value = value;
        this.parentMessage.emit(msg);
    }
    @Output() valueChanged: EventEmitter<v_SupplierLocationBus> = new EventEmitter<v_SupplierLocationBus>();
    protected changed() {
        this.sendParentMessage(MessageType.changed);
        let data: any = this.getData();
        this.valueChanged.emit(data);
    }
    test() {
        let hrs = DateFunctions.dateDiffHours(this._supplierLocation.certInsuranceEndDt);
        console.log("supp-info->test: ", this._supplierLocation, hrs, this);
    }
}
